import { openPdf } from "../utils/downloadPdf";

export function downloadCustomerServiceAgreement(id, filename) {
  return openPdf(
    `/client/customer-services/${id}/agreement.pdf`,
    filename || `agreement-${id}.pdf`
  );
}

export default {
  downloadCustomerServiceAgreement,
};
